
    <ng-container *ngIf="vm$ | async as vm">
      <div
        *ngIf="vm.show"
        class="fixed inset-x-0 bottom-0 z-50 p-3 sm:p-4"
        role="region"
        aria-label="Install nibni app"
      >
        <div class="mx-auto max-w-3xl rounded-2xl border border-[color:var(--border)] bg-[color:var(--card)] shadow-lg">
          <div class="flex items-start gap-3 p-4">
            <div class="flex-1 min-w-0">
              <div class="text-sm font-semibold text-[color:var(--foreground)]">Install nibni</div>
              <div class="mt-1 text-xs text-[color:var(--muted-foreground)]" *ngIf="!vm.isIos">
                Get quicker access and an app-like experience.
              </div>
              <div class="mt-1 text-xs text-[color:var(--muted-foreground)]" *ngIf="vm.isIos">
                iPhone/iPad: Tap <span class="font-semibold">Share</span> → <span class="font-semibold">Add to Home Screen</span>.
              </div>
            </div>

            <div class="flex gap-2 shrink-0">
              <button
                type="button"
                class="px-3 py-2 text-xs rounded-lg border border-[color:var(--border)] bg-transparent hover:bg-[color:var(--hover)]"
                (click)="dismiss()"
              >
                Not now
              </button>
              <button
                *ngIf="vm.canInstall && !vm.isIos"
                type="button"
                class="px-3 py-2 text-xs rounded-lg bg-[color:var(--primary)] text-[color:var(--primary-foreground)] hover:bg-[color:var(--primary-hover)]"
                (click)="install()"
              >
                Install
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  
